import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let MenuItemsDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-menu-items';
        }
    }
});
export const MenuItemsPlugin = {
    name: 'e-menu-items',
    install(Vue) {
        Vue.component(MenuItemsPlugin.name, MenuItemsDirective);
    }
};
export let MenuItemDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-';
        }
    }
});
export const MenuItemPlugin = {
    name: 'e-',
    install(Vue) {
        Vue.component(MenuItemPlugin.name, MenuItemDirective);
    }
};
